import * as React from 'react';
declare const I18n;

import Header from '../../../Header';
import TextInput from '../../../inputs/TextInput';
import BreadCrumb from '../../../BreadCrumb';
import AnnouncementBar from '../../../AnnouncementBar/AnnouncementBar';
import api from '../../../../api';

const MAX_DESCRIPTION_WORDS = 15;

const countWords = (text: string): number =>
  text.trim() ? text.trim().split(/\s+/).length : 0;

type Props = {
  initialData?: {
    error?: string;
  };
};

const CreateCategory: React.FunctionComponent<Props> = ({
  initialData,
}: Props): JSX.Element => {
  const [nameEn, setNameEn] = React.useState('');
  const [nameFr, setNameFr] = React.useState('');
  const [descriptionEn, setDescriptionEn] = React.useState('');
  const [descriptionFr, setDescriptionFr] = React.useState('');

  const [errorNameEn, setErrorNameEn] = React.useState('');
  const [errorNameFr, setErrorNameFr] = React.useState('');
  const [errorDescriptionEn, setErrorDescriptionEn] = React.useState('');
  const [errorDescriptionFr, setErrorDescriptionFr] = React.useState('');
  const [announcementError, setAnnouncementError] = React.useState(initialData?.error || '');

  const [loading, setLoading] = React.useState(false);

  const validateDescription = (
    value: string,
    setError: (msg: string) => void
  ): boolean => {
    if (!(value && value.trim())) {
      setError("This field can't be blank");
      return true;
    }

    if (countWords(value) > MAX_DESCRIPTION_WORDS) {
      setError(I18n.t('models.course.type.category_description_help'));
      return true;
    }

    return false;
  };

  const handleSubmit = () => {
    setLoading(true);
    setAnnouncementError('');

    let error = false;

    if (!(nameEn && nameEn.trim())) {
      setErrorNameEn("This field can't be blank");
      error = true;
    }

    if (!(nameFr && nameFr.trim())) {
      setErrorNameFr("This field can't be blank");
      error = true;
    }

    if (validateDescription(descriptionEn, setErrorDescriptionEn)) {
      error = true;
    }

    if (validateDescription(descriptionFr, setErrorDescriptionFr)) {
      error = true;
    }

    if (error) {
      setLoading(false);
      return;
    }

    api
      .createCategory({
        category: {
          name: nameEn.trim(),
          name_fr: nameFr.trim(),
          description: descriptionEn.trim(),
          description_fr: descriptionFr.trim(),
        },
      })
      .then((res) => {
        if (res?.url) {
          window.location.href = res.url;
          return;
        }

        setAnnouncementError(I18n.t('views.forms.messaging.bad_submission'));
        setLoading(false);
      })
      .catch((err) => {
        const responseError = err?.response?.data?.error;
        if (responseError) {
          setAnnouncementError(responseError);
        }
        setLoading(false);
      });
  };

  return (
    <div className="new_course">
      {announcementError && (
        <div className="header__top-bar alert alert-info">{announcementError}</div>
      )}

      <Header
        title={I18n.t('models.course.type.create_category')}
      />

      <BreadCrumb
        locations={[
          { title: I18n.t('models.course.attributes.courses'), url: '/admin/courses' },
          { title: I18n.t('models.course.type.create_category'), url: null },
        ]}
      />

      <div className="col-md-12" style={{ marginTop: 60 }}>
        <label className="required">
          {I18n.t('models.course.type.category_name')}
        </label>
      </div>

      <TextInput
        columnSize={6}
        error={errorNameEn}
        value={nameEn}
        type="category"
        field="name"
        label={I18n.t('views.common.english')}
        style={{ padding: 0 }}
        className="required"
        onChange={(value) => {
          setNameEn(value);
          setErrorNameEn('');
          setAnnouncementError('');
        }}
      />

      <TextInput
        columnSize={6}
        error={errorNameFr}
        value={nameFr}
        type="category"
        field="name_fr"
        label={I18n.t('views.common.french')}
        style={{ padding: 0 }}
        className="required"
        onChange={(value) => {
          setNameFr(value);
          setErrorNameFr('');
          setAnnouncementError('');
        }}
      />

      <div className="col-md-12" style={{ marginTop: 30 }}>
        <label className="required">
          {I18n.t('models.course.type.category_description')}
        </label>
        <div
          style={{ fontSize: '1rem', fontWeight: 500, lineHeight: '1.75rem', marginBottom: '1rem' }}
        >
          {I18n.t('models.course.type.category_description_help')}
        </div>
      </div>

      <TextInput
        columnSize={6}
        error={errorDescriptionEn}
        value={descriptionEn}
        type="category"
        field="description"
        label={I18n.t('views.common.english')}
        style={{ padding: 0 }}
        className="required"
        onChange={(value) => {
          setDescriptionEn(value);
          setErrorDescriptionEn('');
        }}
      />

      <TextInput
        columnSize={6}
        error={errorDescriptionFr}
        value={descriptionFr}
        type="category"
        field="description_fr"
        label={I18n.t('views.common.french')}
        style={{ padding: 0 }}
        className="required"
        onChange={(value) => {
          setDescriptionFr(value);
          setErrorDescriptionFr('');
        }}
      />

      <div className="col-12 text-center mt-5">
        <button
          type="button"
          name="commit"
          disabled={loading}
          className="btn btn-primary pull-right"
          onClick={handleSubmit}
        >
          {I18n.t('views.forms.submit')}
          {loading && <i className="far fa-spinner-third fa-spin btn-loader ml-2" />}
        </button>
      </div>
    </div>
  );
};

export default CreateCategory;
